import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Feature, GeoJSONSource } from 'maplibre-gl';
import { GeoJSONStatisticsQueryRequest } from '../../interfaces/titiler/CogStatisticsQueryRequest';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IZoom } from '../../interfaces/explorer/interfaces/IZoom';

@Injectable({
  providedIn: 'root'
})
export class TitilerNewService {

  private TITILER_URL: string = environment.services.urlTITILER;
  private readonly MAP_SERVER_URL = environment.services.urlTITILER;
  private STATISTICS_URL: string = `${this.TITILER_URL}/cog/statistics`;
  private readonly INFO_ENDPOINT = `${this.MAP_SERVER_URL}/cog/info.geojson`;
  
  private http: HttpClient = inject(HttpClient)

  constructor() { }


  /**
   * @description
   * Fetches statistics from a raster data source.
   *
   * @param query A GeoJSONStatisticsQueryRequest object that contains the URL of the raster to query.
   * @param body A GeoJSON object that must contain the Geometry of the area to query.
   *
   * @returns An observable of GeoJSONStatisticsResponse.
   */
  cogStatistics(query: GeoJSONStatisticsQueryRequest, body: GeoJSON.GeoJSON): Observable<GeoJSON.GeoJSON> {

    let params = new HttpParams()
      .set("url", query.url);

    return this.http.post<GeoJSON.GeoJSON>(this.STATISTICS_URL, body, { params });
  }
//  zoomToRaster(cogUrl: string): Observable<IZoom> { //simulazione zoom
//   const mockZoomInfo: IZoom = {
//     bounds: [24.6, 59.35, 24.85, 59.5],
//     center: [24.75, 59.42], 
//     minzoom: 8,
//     maxzoom: 16
//   };
//   return new Observable((observer) => {
//     observer.next(mockZoomInfo);
//     observer.complete();
//   });
// }
zoomToRaster(cogUrl: string): Observable<IZoom> {
  const isS3 = cogUrl.startsWith('s3://');
  const finalUrl = isS3 ? cogUrl : encodeURIComponent(cogUrl);
  
  const params = new HttpParams().set('url', finalUrl);

  return this.http.get<any>(this.INFO_ENDPOINT, { params }).pipe(
    map((response: any) => {
      const bbox = response.bbox as number[];
      if (!bbox || bbox.length !== 4) {
        throw new Error('Bounding box not available');
      }

      const [minX, minY, maxX, maxY] = bbox;
      const centerX = (minX + maxX) / 2;
      const centerY = (minY + maxY) / 2;

      const zoomInfo: IZoom = {
        bounds: [minX, minY, maxX, maxY],
        center: [centerX, centerY],
        minzoom: 8,
        maxzoom: 18
      };

      return zoomInfo;
    })
  );
}



  
}
